import { Quote } from "lucide-react";

export default function FounderNote() {
  return (
    <section data-testid="founder-section" id="founder" className="bg-[var(--bone-2)] py-24 md:py-32 relative overflow-hidden">
      <div className="container-x grid grid-cols-12 gap-10 items-start">
        <div className="col-span-12 md:col-span-4">
          <div className="overline text-[var(--terracotta)]">A note from the founder</div>
          <p className="font-mono text-xs text-[var(--muted)] mt-6 leading-relaxed">
            02 / Founder<br/>
            Ella Iwere<br/>
            Engineer · Educator · Founder<br/>
            Lagos · Nigeria
          </p>
          <div className="mt-10 hidden md:block">
            <Quote className="w-16 h-16 text-[var(--terracotta)]/30 -scale-x-100" strokeWidth={1} />
          </div>
        </div>

        <div className="col-span-12 md:col-span-8 md:pl-8 md:border-l md:border-black/10">
          <Quote className="w-10 h-10 md:hidden text-[var(--terracotta)]/40 mb-4" strokeWidth={1.5} />

          <div className="font-serif text-2xl md:text-3xl lg:text-[2.25rem] leading-[1.4] tracking-[-0.01em] text-[var(--ink)] space-y-6">
            <p>
              My passion for education began when I witnessed the stark difference between
              the opportunities I had and the challenges many other children faced. While I
              attended a private school, countless students struggled to learn in
              torn-down classrooms that were dirty, overcrowded, and under-resourced —
              rooms barely fit for teaching, let alone for learning.
            </p>
            <p>
              Seeing their determination despite these obstacles left a lasting impression
              on me. Today, through our work, we are committed to ensuring that{" "}
              <em className="text-[var(--terracotta)] not-italic">no child is denied a quality education because of poverty or lack of resources.</em>
            </p>
            <p>
              As an engineer, I am particularly dedicated to promoting STEM education and
              empowering young girls to pursue careers in science, technology, engineering,
              and mathematics. I firmly believe that when you educate a girl, you invest in
              generations to come.
            </p>
            <p>
              Together, we can create a future where every child has the tools, support,
              and opportunity to succeed.
            </p>
          </div>

          <div className="mt-12 flex items-center gap-5 border-t border-black/10 pt-8">
            <div className="w-14 h-14 grid place-items-center bg-[var(--forest)] text-[var(--bone)] font-serif text-2xl">
              EI
            </div>
            <div>
              <div className="font-serif text-xl text-[var(--ink)]">— Ella Iwere</div>
              <div className="overline text-[var(--muted)] mt-1">Founder · Irene Foundation</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
